/**
 * --------------------------------------------------
 * configuration for global need
 * --------------------------------------------------
 */

export const version = "0.3.1";
